export default {
  data() {
    return {
      page: 1,
      newPage: 1,
      pageSize: 10,
      newPageSize: 10,
      totalPages: 0,
      totalRecords: 0,
    };
  },
  mounted() {
    this.initialPagination();
  },
  methods: {
    initialPagination: function () {
      const defaultPage = Number(this.$route.query?.page || '1');
      this.page = defaultPage;
      const defaultPageSize = Number(this.$route.query?.pageSize || '10');
      this.pageSize = defaultPageSize;
      this.newPageSize = defaultPageSize;
    },
  },
  watch: {
    page: function (currentVal) {
      const previousQuery = this.$route.query;
      this.$router.replace({
        query: {
          ...previousQuery,
          page: currentVal,
        },
      });
    },
    pageSize: function (currentVal) {
      if (currentVal > 10) {
        const previousQuery = this.$route.query;
        this.$router.replace({
          query: {
            ...previousQuery,
            page: 1,
            pageSize: currentVal,
          },
        });
      }
    },
    // newPageSize: function (currentVal) {
    //   console.log(currentVal);
    // }
  },
};
